


























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapActions, mapGetters } from 'vuex';
import notificationService from '@/services/notificationService';
import Card from '@/components/default/Card.vue';
import employeesRepository from '@/modules/employees/employeesRepository';
import { selectableEmployees, RoleGroups } from '@/modules/employees/employeeSelection';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel, DxButtonItem } from 'devextreme-vue/form';
import { Project, ProjectCreateCommand, ProjectsClient, ZipClient, TemplateCompanyPrefixDto, ITunnelGroup, Address, ProjectWarrantySettings, TunnelGroupsClient, SettingsClient, Settings, BillingType } from '@/data/web-api-client';
import ProjectMatchingProjectsModal from '@/modules/projects/components/ProjectMatchingProjectsModal.vue';
import cPopup from '@/components/default/Popup.vue';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    ProjectMatchingProjectsModal,
    DxButtonItem,
    cPopup,
  },
  computed: {
    ...mapState('projects', {
      statusses: 'statusses',
    }),
    ...mapGetters('projects', {
      statusIsDeclined: 'getStatusIsDeclined',
    }),
  },
  methods: {
    ...mapActions('projects', {
      fetchData: 'fetch',
    }),
  },
})
export default class ProjectAddPage extends Vue {
  statusses!: IProjectStatus[];
  employees: any[] = [];
  fetchData!: any;
  saving: boolean = false;
  statusIsDeclined!: any;
  tunnelGroups: ITunnelGroup[] = [];
  command = new ProjectCreateCommand({
    name: '',
    status: 0,
    type: '',
    address: new Address({
      addressline1: '',
      city: '',
      zip: '',
      country: '',
    }),
    userId: '',
    customerReference: '',
    caseNumberRsz: '',
    specificProcedures: '',
    checkinAtWork: false,
    termsOfPayment: undefined,
    progressStatementAcceptTerms: undefined,
    wasteDisposalPercentage: undefined,
    cleanUpPercentage: undefined,
    startDate: undefined,
    numberOfPhases: 1,
    requestedExecutionDate: undefined,
    endDate: undefined,
    warranty: new ProjectWarrantySettings({
      enabled: false,
      amount: 0,
      released: '',
    }),
    provideSafetyHealthEnvironmentPlan: false,
    provideRiskAnalysis: false,
    provideInsuranceAttest: false,
    provideTechnicalFiles: false,
    penaltyClause: false,
    penaltyClauseValue: '',
    overrideAndCreateNew: false,
    siteLabel: '',
    tunnelGroupsId: undefined,
  });

  settings: Settings | undefined;

  matchingProjects: Project[] = [];
  showMatchingProjectsModal: boolean = false;

  projectsClient = new ProjectsClient(undefined, this.$axios);
  settingsClient = new SettingsClient(undefined, this.$axios);
  templateCompanyPrefixes: TemplateCompanyPrefixDto[] = [];

  showSiteLabelPopup = false;
  siteLabelForm = {
    name: '',
  };

  siteLabelOptions = {
    dataSource: new DataSource({
      store: new dxCustomStore({
        load: async (loadOptions) => {
          const catalog = this.$store.getters['catalogs/list']('SiteLabels');

          let values = [...catalog.values];

          if (catalog.values && loadOptions && loadOptions.searchOperation === 'contains' && loadOptions.searchValue) {
            values = values.filter((v: string) => v.toLowerCase() === loadOptions.searchValue.toLowerCase() || v.toLowerCase().includes(loadOptions.searchValue.toLowerCase()));
          }

          return values;
        },
        byKey: async (val: any) => {
          return val;
        },
      }),
      paginate: false,
    }),
    searchEnabled: true,
    showClearButton: true,
    onOpened: async (e: any) => {
      await this.siteLabelOptions.dataSource.reload();
    },
  };

  async created() {
    this.fetchData();
    this.loadEmployees();
    this.loadTunnelGroups();
    this.getTemplateCompanyPrefixes();
    this.settings = await this.settingsClient.get();
    this.command.wasteDisposalPercentage = this.settings.defaultWasteDisposalPercentage;
    this.command.cleanUpPercentage = this.settings.defaultCleanUpPercentage;
  }

  public calculateName() {
    if (!this.command.name || this.command.name === '') {
      if (this.command.address && this.command.address.addressline1 !== '' && this.command.address.city !== '') {
        const form: any = this.$refs.projectForm;
        form.instance.updateData('name', `${this.command.address.city}, ${this.command.address.addressline1}`);
      }
    }
  }

  async loadEmployees() {
    try {
      this.employees = (await employeesRepository.get()).data;
    } catch {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het inladen van de medewerkers');
    }

    // OS-214: resolves (and caches) which employees are selectable as project leader / quality
    // guard, based on O365 group membership. Cached in the store, so this is a no-op after the
    // first call in the app session.
    this.$store.dispatch('employees/fetchRoleGroups', { axios: this.$axios });
  }

  private async loadTunnelGroups() {
    try {
      this.tunnelGroups = await new TunnelGroupsClient(undefined, this.$axios).get();
    } catch {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het inladen van de tunnelgroepen');
    }
  }

  async save(overrideAndCreateNew: boolean = false) {
    this.command.overrideAndCreateNew = overrideAndCreateNew;

    try {
      this.$nextTick(async () => {
        const validationResult = (this.$refs.projectForm as any).instance.validate();

        if (validationResult.isValid) {
          this.saving = true;
          this.projectsClient
            .postProject(this.command)
            .then((project: Project) => {
              notificationService.saved();
              this.$router.push({ path: `/projects/${project.id}` });
            })
            .catch((error) => {
              if (error.response.Message.includes('Er bestaat al een project met deze straat en postcode')) {
                this.projectsClient.getMatchingProjects(this.command.address!.addressline1, this.command.address!.zip).then((projects: Project[]) => {
                  this.matchingProjects = projects;
                  this.showMatchingProjectsModal = projects.length > 0;
                  this.saving = false;
                });
              }
            });
        } else {
          notificationService.invalidForm();
        }
      });
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  hideMatchingProjectsModal() {
    this.showMatchingProjectsModal = false;
  }

  private async getTemplateCompanyPrefixes() {
    this.templateCompanyPrefixes = await this.projectsClient.getTemplateCompanyPrefixes();
  }

  resetSiteLabelPopup() {
    this.showSiteLabelPopup = false;
    this.siteLabelForm.name = '';
  }

  async saveSiteLabel() {
    await this.$store.dispatch('catalogs/addValue', {
      name: 'SiteLabels',
      value: this.siteLabelForm.name,
    });

    this.command.siteLabel = this.siteLabelForm.name;

    this.resetSiteLabelPopup();
  }

  get statusOptions() {
    return { items: this.statusses, valueExpr: 'value', displayExpr: 'name' };
  }

  get projecttypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');

    return {
      items: catalog ? catalog.values : [],
      searchEnabled: true,
    };
  }

  get projectSourceOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectSources');
    return {
      items: catalog ? catalog.values : [],
      searchEnabled: true,
      showClearButton: true,
    };
  }

  // OS-214: AAD id sets that gate the project leader / quality guard pickers, fetched once and
  // cached in the employees store (see loadEmployees()).
  get roleGroups(): RoleGroups {
    return {
      projectLeaderIds: this.$store.getters['employees/projectLeaderIds'],
      qualityGuardIds: this.$store.getters['employees/qualityGuardIds'],
    };
  }

  // OS-214: this is a "create new" screen, so there is no already-assigned employee to
  // preserve yet - but keep passing currentValue anyway so the same helper/behaviour applies
  // if the form is ever prefilled (e.g. duplicating a project).
  get projectLeaderOptions() {
    return {
      items: selectableEmployees(this.employees, { role: 'projectLeader', roleGroups: this.roleGroups, currentValue: this.command.userId }),
      valueExpr: 'id',
      displayExpr: 'displayName',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get qualityGuardOptions() {
    return {
      items: selectableEmployees(this.employees, { role: 'qualityGuard', roleGroups: this.roleGroups, currentValue: this.command.qualityGuardId }),
      valueExpr: 'id',
      displayExpr: 'displayName',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get paymentOptions() {
    const options = [
      { text: this.$t('objects.projects.TermsOfPaymentOptions.0'), value: 7 },
      { text: this.$t('objects.projects.TermsOfPaymentOptions.1'), value: 14 },
      { text: this.$t('objects.projects.TermsOfPaymentOptions.2'), value: 30 },
    ];
    return {
      dataSource: options,
      valueExpr: 'value',
      displayExpr: 'text',
      searchEnabled: false,
      showClearButton: false,
      showCancelButton: false,
    };
  }

  get zipOptions() {
    const self = this;
    return {
      onChange: async (e: any) => {
        if (!self.command.address) {
          return;
        }

        const result = await new ZipClient(undefined, self.$axios).getCityByZip(self.command.address.zip!);

        if (result) {
          self.command.address.city = result.hoofdgemeente;
        } else {
          self.command.address.city = '';
        }
      },
    };
  }

  get templateCompanyPrefixOptions() {
    const items = this.templateCompanyPrefixes.map((prefix) => {
      return {
        display: prefix.displayName,
        value: prefix.prefix,
      };
    });

    return {
      items: items,
      displayExpr: 'display',
      valueExpr: 'value',
    };
  }

  get siteLabelButtonOptions() {
    const self = this;

    return {
      text: '+',
      onClick: () => {
        self.showSiteLabelPopup = true;
      },
    };
  }

  get tunnelGroupsOptions() {
    const items = this.tunnelGroups.map((dg) => ({
      value: dg.id,
      text: dg.name,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }

  get billingTypeOptions() {
    const items = [
      {
        value: BillingType.AdvanceInvoice,
        text: 'Voorschotfactuur'
      },
      {
        value: BillingType.ProgressStatement,
        text: 'Vorderstaat'
      }
    ];

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }
}
